import { render } from "./p-table.vue?vue&type=template&id=5e37745e&scoped=true"
import script from "./p-table.vue?vue&type=script&lang=js"
export * from "./p-table.vue?vue&type=script&lang=js"

import "./p-table.vue?vue&type=style&index=0&id=5e37745e&scoped=true&lang=scss"
import "./p-table.vue?vue&type=style&index=1&id=5e37745e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e37745e"],['__file',"src/components/p-table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e37745e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e37745e', __exports__)) {
    api.reload('5e37745e', __exports__)
  }
  
  module.hot.accept("./p-table.vue?vue&type=template&id=5e37745e&scoped=true", () => {
    api.rerender('5e37745e', render)
  })

}


export default __exports__